import axios from 'axios'

export const state = () => ({
  stores:[]
});

export const getters = {
  stores_HIBOUTIK : (state) => {
    return state.stores;
  }
};

export const mutations = {
  STORES_LOAD(state) {

  },
  STORES_SUCCES(state,stores) {
    try{
      state.stores = stores;
    }catch (e) {
    }
  },
  STORES_ERROR(state) {

  },
  STORES_LOADED(state) {

  },
};

export const actions = {
  async getStores({commit}) {
    commit('STORES_LOAD');
    axios.get(process.env.API+'stores/get')
      .then(response => {
        commit('STORES_SUCCES', response.data.payload);
      })
      .catch(error => {
        commit('STORES_ERROR');
      })
      .finally(() => commit('STORES_LOADED'));
  },
};
